import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams,RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';


@Injectable()
export class PropertyService {
    constructor(
        private apiRequest: ApiRequestService,
        private translate:TranslateService
    ) {}

      getAllOccupations(){
        let me = this;
   
        
        let occupationDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.get('occupation/fetchAll/')
            .subscribe(jsonResp => {
         
                let returnObj = jsonResp;
                console.log(returnObj);
                occupationDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return occupationDataSubject;

    }


    getProductStatsByQuantityOrdered(): Observable<any> {
        return this.apiRequest.get('api/product-stats-by-quantity');
    }


}
